import React, { useEffect, useState } from 'react'
import DumoHeader from './DumoHeader'
import { getActiveAchievements, getFinishedAchievements } from '../../server/server'
import SingleAchievement from './SingleAchievement'
import LoadingSpinner from './LoadingSpinner'
import AchievementInfoModal from '../Modal/AchievementInfoModal'
import TransferDumoPointsModal from '../Modal/TransferDumoPointsModal'
import { useTranslation } from 'react-i18next'
import ArchiveIcon from '../../svg/ArchiveIcon'
import ConnectToDummoModal from '../Modal/ConnectToDummoModal'
import ConfirmationUnlinkAccountModal from '../Modal/ConfirmationUnlinkAccountModal'

function Dumo() {
    const { t } = useTranslation()
    const [selectedType, setSelectedType] = useState('achievements')
    const [transferDumoModalOpen, setTransferDumoModalOpen] = useState(false)
    const [connectToDummoOpen, setConnectToDummoOpen] = useState(false)
    const [activeAchievements, setActiveAchievements] = useState([])
    const [finishedAchievements, setFinishedAchievements] = useState([])
    const [selectedAchievement, setSelectedAchievement] = useState({})
    const [achievementInfoOpen, setAchievementInfoOpen] = useState(false)
    const [confirmationUnlinkOpen, setConfirmationUnlinkOpen] = useState(false)
    const [loading, setLoading] = useState(false)

    const closeAchievementInfoModal = () => {
        setAchievementInfoOpen(false)
    }

    const openAchievementInfoModal = (item) => {
        setAchievementInfoOpen(true)
        setSelectedAchievement(item)
    }

    const closeTransferDumoModal = () => {
        setTransferDumoModalOpen(false)
    }

    const closeConnnectToDummoModal = () => {
        setConnectToDummoOpen(false)
    }

    const closeConfirmationUnlinkModal = () => {
        setConfirmationUnlinkOpen(false)
    }

    const unlinkUserAccount = () => {
        setConnectToDummoOpen(false)
        setConfirmationUnlinkOpen(true)
    }

    const changeType = (type) => {
        setSelectedType(type)
        setLoading(true)
        if (type == 'archive') loadFinishedAchievements()
        else loadActiveAchievements()
    }

    useEffect(() => {
        loadActiveAchievements()
    }, [])

    const loadActiveAchievements = async () => {
        setLoading(true)
        const resp = await getActiveAchievements()
        if (resp.status === 200) {
            const data = resp.data
            setActiveAchievements(data)
            setLoading(false)
        } else {
            setLoading(false)
        }
    }

    const loadFinishedAchievements = async () => {
        const resp = await getFinishedAchievements()
        if (resp.status === 200) {
            const data = resp.data
            setFinishedAchievements(data)
            setLoading(false)
        }
    }

    const isArchive = selectedType === 'archive'
    const selectedArray = isArchive ? finishedAchievements : activeAchievements

    return (
        <div className="dumo-section-container">
            <DumoHeader setTransferDumoModalOpen={setConnectToDummoOpen} />
            <div className="tasks-achievements-header">
                <button className={`dumo-list-title ${!isArchive ? 'selected' : ''}`} onClick={() => changeType('achievements')}>
                    {t('Achievements')}
                </button>
                <button className={`dumo-list-title achievement-archive ${isArchive ? 'selected' : ''}`} onClick={() => changeType('archive')}>
                    <ArchiveIcon color={isArchive ? 'white' : '#bebece'} />
                    <span>{t('archive')}</span>
                </button>
            </div>
            <div style={{ marginTop: 15, overflow: 'auto' }}>
                {selectedArray.map((achievement, index) => {
                    return (
                        <div style={{ marginBottom: 10 }} key={achievement.name} onClick={() => openAchievementInfoModal(achievement)}>
                            <SingleAchievement item={achievement} />
                        </div>
                    )
                })}
                {loading && <LoadingSpinner color="#7ec5c6" height={150} />}
            </div>
            <AchievementInfoModal modalIsOpen={achievementInfoOpen} closeModal={closeAchievementInfoModal} achievement={selectedAchievement} />
            <TransferDumoPointsModal closeModal={closeTransferDumoModal} modalIsOpen={transferDumoModalOpen} />
            <ConnectToDummoModal modalIsOpen={connectToDummoOpen} closeModal={closeConnnectToDummoModal} unlinkUserAccount={() => unlinkUserAccount()} />
            <ConfirmationUnlinkAccountModal
                modalIsOpen={confirmationUnlinkOpen}
                closeModal={closeConfirmationUnlinkModal}
                message={'Are you sure you want to unlink account?'}
                subMessage={'You will need to add new dummo account to transfer points'}
            />
        </div>
    )
}

export default Dumo
